module.exports = __webpack_public_path__ + "static/media/goods4_1.d4c96a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods4_1.png
// module id = 1231
// module chunks = 0